<template>
  <div class="header-container">
    <i class="fas fa-bread-slice"></i>
    <h1 class="title">
      Vue with Toast
    </h1>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.header-container {
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid #dee2e6;
}

.title {
  font-size: 20px;
}

.fa-bread-slice {
  display: block;
  margin-right: 10px;
  font-size: 1.3em;
  color: #bc9a83;
}
</style>
